import React from "react";
import {Container, Row, Tab, Tabs} from "react-bootstrap";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import "./AuditComponent.css";
import auditConfig from "./auditConfig";
import AuditTab from "./AuditTab";
import {getUser} from "../../helpers/jwt";
import { useTranslation } from "react-i18next";

const AuditComponent = ({ setLoader }) => {
  const { t } = useTranslation();

  function createTab(tab) {
    return <Tab eventKey={tab.type} title={tab.title}>
      <AuditTab tab={tab} setLoader={setLoader}/>
    </Tab>;
  }

  return (

    <>


      <Container fluid className="mt-3 auditContainer">
        <Tabs defaultActiveKey={auditConfig(t).defaultTab} transition={false} id="noanim-tab-example-2">
          {
            auditConfig(t).tabs.map(tab => createTab(tab))
          }
        </Tabs>
      </Container>
    </>
  );
};

export default AuditComponent;
